<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Notificações</h6> <button
                            class="btn btn-warning btn-sm" @click="loadData()"><i class="fa fa-undo"></i> Recarregar
                            dados</button>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Título</th>
                                        <th>Data notificação</th>
                                        <th>Status</th>
                                        <th colspan="2"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(notification, index) in notifications" :key="notification.id">
                                        <td class="pointer" @click="openModalViewNotification(notification.id)">{{ index + 1 }}</td>
                                        <td class="pointer" @click="openModalViewNotification(notification.id)">{{ notification.title }} </td>
                                        <td class="pointer" @click="openModalViewNotification(notification.id)">{{ notification.created_at_formatted }}</td>
                                        <td v-if="notification.read"> <span class="badge badge-success"> Lida</span></td>
                                        <td v-else> <span class="badge badge-danger">Não lida</span></td>
                                        <td class="text-center"><button class="btn btn-info" @click="openModalViewNotification(notification.id)"><i class="fa fa-eye"></i> Ver notificação</button></td>
                                        <td v-if="!notification.read"><button class="btn btn-warning"
                                                @click="notificationToRead(notification.id)"><i class="fa fa-check"></i>
                                                Marcar como lida</button></td>
                                        <td v-if="notification.read"><button disabled class="btn btn-success"><i
                                                    class="fa fa-check"></i> Lida</button></td>
                                    </tr>
                                    <tr v-if="notifications.length > 0 && page > 1">
                                        <td colspan="6" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="notifications.length <= 0">
                                        <td colspan="6" class="text-center">Nenhuma notificação encontrada</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<ViewNotification :modalDisplayViewNotification="modalDisplayViewNotification" :title="titleNotification"
        :description="descriptionNotification" @update:closeModalNotification="closeModalNotification" @update:markNotificationRead="markNotificationRead"
        :notification_by="notification_by" :read="readNotification" :created_at="createdAtNotification" :notification_id="notification_id">
    </ViewNotification>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import ViewNotification from '../notification/view-notification.vue';

import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: { Loading,ViewNotification },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: {},
            notifications: [],
            page: 1,
            last_page: 1,
            total_itens: 0,
            modalDisplayViewNotification: 'none',
            titleNotification: '',
            descriptionNotification: '',
            notification_by: '',
            readNotification:false,
            createdAtNotification:'',
            notification_id:0
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        }
    },
    methods: {
        onCancel() { },
        loadData() {
            this.isLoading = true;
            api.get('/notification-user', {
                params: {
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                   
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.notifications = response.data.notifications;
                    } else {
                        this.notifications = this.notifications.concat(response.data.notifications);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        notificationToRead(id) {
            this.$confirm(
                {
                    message: 'Deseja marcar a notificação como lida?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('/notification-user/' + id)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Notificação marcada como lida",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

         openModalViewNotification(notification_id) {
            this.isLoading = true;
            api.get('notification-user/' + notification_id)
                .then(response => {
                    const notification = response.data.notification;
                    this.titleNotification = notification.title;
                    this.descriptionNotification = notification.description;
                    this.notification_by = notification.notification_created_by;
                    this.readNotification= notification.read;
                    this.createdAtNotification = notification.created_at_formatted;
                    this.notification_id = notification.id;
                    this.modalDisplayViewNotification = 'block';
                    this.isLoading = false;
                    this.loadData();
                })
                .catch(error => {
                    this.isLoading = false;
                    console.error("Error fetching data:", error);
                });

        },
         closeModalNotification(value) {
            this.modalDisplayViewNotification = value;
        },
         markNotificationRead(notification_id) {
            api.post('notification-user/'+notification_id)
                .then(() => {
                   this.modalDisplayViewNotification = 'none';
                    this.loadData();
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        }

    },
    mounted() {
        this.loadData();

    },
}
</script>

<style>
.pointer{
    cursor: pointer;
}
</style>